import { useEffect } from 'react';

import { shouldUseOldPuzzel } from 'src/custom-hooks/use-live-chat';
import type { BuildType } from 'src/enums/build/build-type';
import { updateChatVariables } from 'src/helpers/puzzel';

type RouteUpdateHandlerProps = { buildType: BuildType; pathname: string };

export const useRouteUpdateHandler = ({ buildType, pathname }: RouteUpdateHandlerProps) => {
  useEffect(() => {
    if (shouldUseOldPuzzel(buildType)) {
      updateChatVariables({ page: pathname });
    }
  }, [pathname, buildType]);
};
